import active_device_i from './active-device.png'
import active_gateway_i from './active-gateway.png'
import error_device_i from './error-device.png'
import warning_device_i from './warning-device.png'
import error_gateway_i from './error-gateway.png'
import faded_device_i from './faded-device.png'
import faded_gateway_i from './faded-gateway.png'
import default_device_i from './default-device.png'
import default_gateway_i from './default-gateway.png'

var icon_d = (icon) => ({
  url: icon,
  anchor: {x: 28, y: 28,},
});
var icon_g = (icon) => ({
  url: icon,
  anchor: {x: 28, y: 28,},
});

export var active_device = icon_d(active_device_i);
export var active_gateway = icon_g(active_gateway_i);
export var error_device = icon_d(error_device_i);
export var warning_device = icon_d(warning_device_i);
export var error_gateway = icon_g(error_gateway_i);
export var faded_device = icon_d(faded_device_i);
export var faded_gateway = icon_d(faded_gateway_i);
export var default_device = icon_d(default_device_i);
export var default_gateway = icon_d(default_gateway_i);

var markers = {
  active_device,
  active_gateway,
  error_device,
  warning_device,
  error_gateway,
  faded_device,
  faded_gateway,
  default_device,
  default_gateway,
};

export default markers;


// WEBPACK FOOTER //
// ./src/apps/feelgrid/assets/markers/index.js